// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import TerceraColorStyleWidthPickerTemplate from '@front/templates/TerceraColorStyleWidthPickerTemplate.html';
import { ContainerControl } from './ContainerControl';
import { LineStyleUtils } from '@shared/commons/UtilsClasses/LineStyleUtils';
export class TerceraColorStyleWidthPicker extends ContainerControl {
    constructor() {
        super();
        this.onActiveChanged = (event) => {
            void this.set('colorStyleWidth.Checked', event.currentTarget.checked);
        };
    }
    oninit() {
        super.oninit();
        this.ColorStyleWidthChanged = new CustomEvent();
        this.observe('colorStyleWidth', this.onColorStyleWidthChanged);
        this.observe('selectedLineStyleItem selectedLineWidthItem', this.updateLineStyleAndWidth);
        const widthItems = LineStyleUtils.createWidthItems();
        void this.set({ widthItems });
        const lineStyleItems = LineStyleUtils.getCBItems();
        void this.set({ styleItems: lineStyleItems });
    }
    updateLineStyleAndWidth() {
        const colorStyleWidth = this.get('colorStyleWidth');
        if (isNullOrUndefined(colorStyleWidth))
            return;
        const selectedLineStyleItem = this.get('selectedLineStyleItem');
        if (!isNullOrUndefined(selectedLineStyleItem)) {
            void this.set('colorStyleWidth.Style', selectedLineStyleItem.value);
        }
        const selectedLineWidthItem = this.get('selectedLineWidthItem');
        if (!isNullOrUndefined(selectedLineWidthItem)) {
            void this.set('colorStyleWidth.Width', selectedLineWidthItem.value);
        }
    }
    onColorStyleWidthChanged(newCSW, oldCSW, keyPath) {
        if (newCSW && newCSW !== oldCSW) {
            const styleItems = this.get('styleItems');
            const lineStyleItem = styleItems.find((item) => item.value === newCSW.Style);
            const widthItems = this.get('widthItems');
            const lineWidthItem = widthItems.find((item) => item.value === newCSW.Width);
            void this.set({
                selectedLineStyleItem: lineStyleItem,
                selectedLineWidthItem: lineWidthItem
            });
        }
        this.ColorStyleWidthChanged.Raise(this, newCSW);
    }
}
ContainerControl.extendWith(TerceraColorStyleWidthPicker, {
    data: function () {
        return {
            height: 32,
            labelText: '',
            colorStyleWidth: null,
            selectedLineStyleItem: null,
            selectedLineWidthItem: null,
            styleItems: [],
            widthItems: [],
            useStyleProperties: false
        };
    },
    template: TerceraColorStyleWidthPickerTemplate
});
